import React from "react";
import { Layout } from "../../layouts/Layout";

const PrivacyPolicy = () => {
  return (
    <Layout footer = {2} breadcrumb={"Privacy Policy"} title={"Privacy Policy"}>
      <br/>
      <h2 style={{paddingBlockStart:'20px'}}>TRIO Management Consultant's Privacy Policy</h2>
      <p>

      This privacy policy sets out how “Trio Management Consultant” uses and protects any information that you give “Trio Management Consultant” when you use this website.
“Trio Management Consultant” is committed to ensuring that your privacy is protected.

      </p>
         </Layout>
  );
};

export default PrivacyPolicy;
